import { render, staticRenderFns } from "./ModificatorDocumentFilter.vue?vue&type=template&id=462383ea"
import script from "./ModificatorDocumentFilter.vue?vue&type=script&lang=js"
export * from "./ModificatorDocumentFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports